import * as styles from './styles.css';
import { Spinner, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { INearbyHousesInfoState } from '../../types/redux/nearbyHousesInfo';

interface IMarketTrendsTitleTooltipParams {
  tooltipInfo: INearbyHousesInfoState;
}
export function MarketTrendsTitleTooltip({ tooltipInfo }: IMarketTrendsTitleTooltipParams) {
  return (
    <div data-testid="marketTrendsTitleTooltipId" className={styles['content']}>
      <div className={styles['head']}>
        <UIText1>Это дома, расположенные в радиусе до 2 километров и похожие друг на друга:</UIText1>
      </div>
      {tooltipInfo.isFetching && <Spinner size={32} />}
      {tooltipInfo.housesInfo?.map(item => (
        <div key={`${item.value}${item.title}`} className={styles['item']}>
          <UIText1 color="text-secondary-default">{item.title}</UIText1>
          <div className={styles['child']}>
            <UIText1>{item.value}</UIText1>
          </div>
        </div>
      ))}
    </div>
  );
}
